<template>
  <div ref="userInfo">
    <header-nav :navInfo="navInfo"
                @backFunc="backFunc"></header-nav>

    <div class="form-div"
         v-if="userData">
      <router-link tag="div"
                   class="from-item"
                   to="/modifyPassword">
        <span class="label">修改密码</span>
        <span class="content"></span>
        <span class="next"></span>
      </router-link>

      <router-link tag="div"
                   class="from-item"
                   :to="{name:'changePhone'}">
        <span class="label">手机号码</span>
        <span class="content">{{userData.user && userPhone(userData.user.tel)}}</span>
        <span class="next"></span>
      </router-link>

      <router-link tag="div"
                   class="from-item"
                   to="/emailManagement">
        <span class="label">邮箱号码</span>
        <span class="content">{{userData.user && userData.user.email}}</span>
        <span class="next"></span>
      </router-link>

    </div>
  </div>
</template>

<script>
import HeaderNav from '@/components/head-nav'
export default {
  name: "index",
  props: ['userData'],
  components: {
    HeaderNav
  },
  data () {
    return {
      navInfo: {
        tit: '个人信息',
      },
    }
  },
  computed: {
    userPhone () {
      return (tel) => {
        return tel.replace(tel.substr(3, 4), '****')
      }
    }
  },
  methods: {
    backFunc () {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="stylus">
.form-div
  width 100%
  height auto
  padding 0 15px
  -webkit-box-sizing border-box
  -moz-box-sizing border-box
  box-sizing border-box

.from-item
  display flex
  align-items center
  width 100%
  height 50px
  padding 5px
  line-height 50px
  border-bottom 1px solid #e6e6e6
  -webkit-box-sizing border-box
  -moz-box-sizing border-box
  box-sizing border-box

.from-item .label
  display inline-block
  font-size 14px
  color #91a6bd
  padding-right 17px

.next
  display inline-block
  width 15px
  height 15px
  margin-left 22px
  background url('~@/assets/user/next.png') no-repeat center center
  -webkit-background-size 100%
  background-size 100%

.content
  flex 1
  color #212121
  font-size 14px
  white-space nowrap
  -ms-text-overflow ellipsis
  text-overflow ellipsis
  overflow hidden
</style>
